import React, { useState, useEffect, useCallback, useRef } from 'react';
import { Helmet } from 'react-helmet';
import MainSidebar from '../../components/ui/MainSidebar';
import Icon from '../../components/AppIcon';

import InspectionSuggestions from './components/InspectionSuggestions';

import QuoteItemForm from './components/QuoteItemForm';
import QuoteItemsList from './components/QuoteItemsList';
import PriceChangeModal from './components/PriceChangeModal';
import QuoteActions from './components/QuoteActions';

import ApprovalRequestForm from './components/ApprovalRequestForm';
import ApprovalTracker from './components/ApprovalTracker';
import { approvalService } from '../../services/approvalService';
import { useAuth } from '../../contexts/AuthContext';
import { supabase } from '../../lib/supabase';
import Button from '../../components/ui/Button';
import { workOrderService } from '../../services/workOrderService';
import { supplierRequestService } from '../../services/supplierRequestService';
import { saleNoteService, quotationService } from '../../services/saleNoteService';
import { useNavigate, useLocation } from 'react-router-dom';
import { sendQuotation, approveQuotationAndCreateWorkOrder, buildWhatsAppMessage, buildEmailBody,  } from '../../services/quotationFlowService';
import EvaModal from '../workshop-dashboard/components/EvaModal';
import SignatureCanvas from '../work-execution/components/SignatureCanvas';
import QuotationPdfTemplate from './components/QuotationPdfTemplate';
import DirectQuotationModal from './components/DirectQuotationModal';
import NavAcciones from '../../components/NavAcciones';
import SavedQuotationDetail from './components/SavedQuotationDetail';


const SALE_NOTE_STATUS_CONFIG = {
  draft: { label: 'Borrador', color: 'text-warning', bgColor: 'bg-warning/10', icon: 'FileText' },
  en_proceso: { label: 'En Proceso', color: 'text-primary', bgColor: 'bg-primary/10', icon: 'Clock' },
  aprobada: { label: 'Aprobada', color: 'text-success', bgColor: 'bg-success/10', icon: 'CheckCircle2' },
  cancelada: { label: 'Cancelada', color: 'text-destructive', bgColor: 'bg-destructive/10', icon: 'XCircle' },
};

const QuotationManagement = () => {
  const { userProfile } = useAuth();
  const navigate = useNavigate();
  const location = useLocation();
  const [sidebarCollapsed, setSidebarCollapsed] = useState(false);
  const [selectedWorkOrder, setSelectedWorkOrder] = useState(null);
  const [quoteItems, setQuoteItems] = useState([]);
  const [selectedSuggestions, setSelectedSuggestions] = useState([]);
  const [priceChangeModal, setPriceChangeModal] = useState({ isOpen: false, item: null });
  const [showSuccessMessage, setShowSuccessMessage] = useState(false);
  const [selectedItemForQuotes, setSelectedItemForQuotes] = useState(null);
  const [showApprovalForm, setShowApprovalForm] = useState(false);
  const [submittingApproval, setSubmittingApproval] = useState(false);
  const [managers, setManagers] = useState([]);
  const [inspectionFindings, setInspectionFindings] = useState([]);
  const [approvingQuote, setApprovingQuote] = useState(false);
  const [generatingQuotation, setGeneratingQuotation] = useState(false);
  const [sendingQuote, setSendingQuote] = useState(false);
  const [whatsAppError, setWhatsAppError] = useState('');
  const [inspectionStatus, setInspectionStatus] = useState(null);
  const [workOrders, setWorkOrders] = useState([]);
  const [loadingWorkOrders, setLoadingWorkOrders] = useState(true);
  const [saleNote, setSaleNote] = useState(null);
  const [quotation, setQuotation] = useState(null);
  const [loadingSaleNote, setLoadingSaleNote] = useState(false);
  const [creatingSaleNote, setCreatingSaleNote] = useState(false);
  const [evaModalOpen, setEvaModalOpen] = useState(false);
  const [inspectionVehicle, setInspectionVehicle] = useState(null);

  // ─── PDF state ──
  const [pdfMode, setPdfMode] = useState(null); // 'preview' | 'generate' | 'print' | null

  // ── NEW: Receptions with inspections (pre-authorization flow) ──
  const [receptions, setReceptions] = useState([]);
  const [loadingReceptions, setLoadingReceptions] = useState(true);
  const [selectedReceptionId, setSelectedReceptionId] = useState(null);
  const [selectorMode, setSelectorMode] = useState('receptions'); // 'receptions' | 'work_orders'

  // Sale note and quotation for selected work order
  const [saleNoteDB, setSaleNoteDB] = useState(null);
  const [quotationDB, setQuotationDB] = useState(null);
  const [loadingSaleNoteDB, setLoadingSaleNoteDB] = useState(false);
  const [creatingSaleNoteDB, setCreatingSaleNoteDB] = useState(false);

  // Add this block - Missing state declarations
  const [workOrderStatus, setWorkOrderStatus] = useState(null);
  const [authorizedItemIds, setAuthorizedItemIds] = useState(new Set());
  const [authToast, setAuthToast] = useState(null);
  const [signatureDataUrl, setSignatureDataUrl] = useState(null);
  const [authorizingQuote, setAuthorizingQuote] = useState(false);
  const [showAuthSection, setShowAuthSection] = useState(false);

  // ── Direct quotation state ──
  const [showDirectModal, setShowDirectModal] = useState(false);
  const [creatingDirectQuote, setCreatingDirectQuote] = useState(false);
  const [directModalInitialData, setDirectModalInitialData] = useState(null);

  // ── Service requests (solicitudes directas) state ──
  const [serviceRequests, setServiceRequests] = useState([]);
  const [loadingServiceRequests, setLoadingServiceRequests] = useState(false);
  const [selectionTab, setSelectionTab] = useState('inspeccionadas'); // 'inspeccionadas' | 'solicitudes'

  // ── Cotizaciones guardadas state ──
  const [mainTab, setMainTab] = useState('cotizar'); // 'cotizar' | 'guardadas'
  const [savedQuotations, setSavedQuotations] = useState([]);
  const [savedSearch, setSavedSearch] = useState('');
  const [savedMonthFilter, setSavedMonthFilter] = useState('');
  const [loadingSavedQuotations, setLoadingSavedQuotations] = useState(false);
  const [selectedSavedQuotation, setSelectedSavedQuotation] = useState(null);

  const mockSuppliers = [
    { id: 'sup1', name: 'Autopartes del Norte', category: 'Refacciones Generales' },
    { id: 'sup2', name: 'Suspensiones Monterrey', category: 'Suspensión y Dirección' },
    { id: 'sup3', name: 'Lubricantes y Filtros SA', category: 'Mantenimiento' },
    { id: 'sup4', name: 'Llantas Express', category: 'Llantas y Rines' },
    { id: 'sup5', name: 'Frenos Profesionales', category: 'Sistema de Frenos' }
  ];

  // Fetch real work orders from DB
  const fetchWorkOrders = useCallback(async () => {
    try {
      setLoadingWorkOrders(true);
      const { data, error } = await supabase?.from('work_orders')?.select(`
          id,
          folio_ot,
          estado_ot,
          fecha_ingreso,
          company_id,
          vehicle:vehicles(marca, modelo, year, placas),
          client:clients(nombre)
        `)?.order('fecha_ingreso', { ascending: false });

      if (error) {
        console.error('Error fetching work orders for quotation:', error);
        setWorkOrders([]);
        return;
      }

      const normalized = (data || [])?.map((wo) => ({
        id: wo?.id,
        folio: wo?.folio_ot,
        vehicle: wo?.vehicle
          ? `${wo?.vehicle?.marca} ${wo?.vehicle?.modelo} ${wo?.vehicle?.year}`
          : wo?.folio_ot,
        client: wo?.client?.nombre || 'Cliente',
        status: wo?.estado_ot,
        companyId: wo?.company_id,
        inspectionDate: wo?.fecha_ingreso
          ? new Date(wo.fecha_ingreso)?.toLocaleDateString('es-MX')
          : '-',
      }));

      setWorkOrders(normalized);
    } catch (err) {
      console.error('Failed to fetch work orders:', err);
      setWorkOrders([]);
    } finally {
      setLoadingWorkOrders(false);
    }
  }, []);

  // Move fetchReceptions before the useEffect that uses it
  // Fetch receptions that have at least one technical_inspection
  const fetchReceptions = useCallback(async () => {
    try {
      setLoadingReceptions(true);
      const { data, error } = await supabase
        ?.from('receptions')
        ?.select(`
          id,
          status,
          odometer,
          motivo_visita,
          created_at,
          company_id,
          vehicles:vehicle_id(id, vin, marca, modelo, year, motor, placas),
          clients:client_id(id, nombre, telefono, email),
          technical_inspections!reception_id(id, status, created_at)
        `)
        ?.order('created_at', { ascending: false })
        ?.limit(50);

      if (error) {
        console.error('[QuotationManagement] Error fetching receptions:', error?.message);
        setReceptions([]);
        return;
      }

      // Filter: only receptions that have at least one inspection record
      const withInspections = (data || [])?.filter(
        r => r?.technical_inspections && r?.technical_inspections?.length > 0
      );

      // Exclude receptions that already have a saved/approved quotation
      const { data: savedRecs } = await supabase
        ?.from('quotations')
        ?.select('reception_id')
        ?.in('status', ['guardada', 'aprobada'])
        ?.not('reception_id', 'is', null);

      const savedRecIds = new Set((savedRecs || [])?.map(q => q?.reception_id));
      const pending = withInspections?.filter(r => !savedRecIds?.has(r?.id));

      setReceptions(pending);
    } catch (err) {
      console.error('[QuotationManagement] fetchReceptions failed:', err);
      setReceptions([]);
    } finally {
      setLoadingReceptions(false);
    }
  }, []);

  // Fetch service_requests that can become direct quotations
  const fetchServiceRequests = useCallback(async () => {
    try {
      setLoadingServiceRequests(true);
      const { data, error } = await supabase
        ?.from('service_requests')
        ?.select(`
          id, request_type, description, urgency, status, notes,
          created_at, client_id, vehicle_id,
          clients(id, nombre, telefono),
          vehicles(id, marca, modelo, year, placas, vin)
        `)
        ?.not('status', 'in', '("cotizacion","cerrada","cancelada")')
        ?.order('created_at', { ascending: false })
        ?.limit(100);

      if (error) {
        console.error('[QuotationManagement] Error fetching service_requests:', error?.message);
        setServiceRequests([]);
        return;
      }
      setServiceRequests(data || []);
    } catch (err) {
      console.error('[QuotationManagement] fetchServiceRequests failed:', err);
      setServiceRequests([]);
    } finally {
      setLoadingServiceRequests(false);
    }
  }, []);

  useEffect(() => {
    fetchManagers();
    fetchWorkOrders();
    fetchReceptions();
    fetchServiceRequests();
  }, [fetchWorkOrders, fetchReceptions]);

  // When navigated from sales-management with a workOrder in state, auto-select it
  useEffect(() => {
    if (location?.state?.workOrder) {
      const wo = location?.state?.workOrder;
      const normalized = {
        id: wo?.id,
        folio: wo?.folio_ot ?? wo?.folioOt ?? wo?.folioOT ?? wo?.folio,
        vehicle: wo?.vehicle
          ? `${wo?.vehicle?.marca} ${wo?.vehicle?.modelo} ${wo?.vehicle?.year}`
          : (wo?.unidad ? `${wo?.unidad?.marca} ${wo?.unidad?.modelo} ${wo?.unidad?.year}` : wo?.folio_ot),
        vin: wo?.vehicle?.vin ?? wo?.unidad?.vin ?? wo?.vin ?? '',
        client: wo?.client?.nombre ?? wo?.cliente?.nombre ?? 'Cliente',
        status: wo?.estado_ot ?? wo?.estadoOt ?? wo?.estadoOT,
        companyId: wo?.company_id ?? wo?.companyId,
        inspectionDate: wo?.fecha_ingreso
          ? new Date(wo.fecha_ingreso)?.toLocaleDateString('es-MX')
          : '-',
      };
      setSelectedWorkOrder(normalized);
    }
  }, [location?.state?.workOrder]);

  // When navigated from Inspection with receptionId in state, auto-select
  useEffect(() => {
    const navReceptionId = location?.state?.receptionId;
    if (navReceptionId && receptions?.length > 0) {
      const found = receptions?.find(r => r?.id === navReceptionId);
      if (found) {
        handleSelectReception(found);
      } else {
        // Fetch directly if not in list yet
        supabase
          ?.from('receptions')
          ?.select(`
            id, status, odometer, motivo_visita, created_at, company_id,
            vehicles:vehicle_id(id, vin, marca, modelo, year, motor, placas),
            clients:client_id(id, nombre, telefono, email),
            technical_inspections!reception_id(id, status, created_at)
          `)
          ?.eq('id', navReceptionId)
          ?.single()
          ?.then(({ data }) => {
            if (data) handleSelectReception(data);
          });
      }
    }
  }, [location?.state?.receptionId, receptions?.length]);

  // When navigated from Solicitudes with fromSolicitud in state, auto-open DirectQuotationModal pre-filled
  useEffect(() => {
    if (location?.state?.fromSolicitud === true) {
      const s = location?.state;
      setDirectModalInitialData({
        solicitudId: s?.solicitudId,
        clientId: s?.clientId,
        vehicleId: s?.vehicleId,
        clientNombre: s?.clientNombre || '',
        clientTelefono: s?.clientTelefono || '',
        vehicleMarca: s?.vehicleMarca || '',
        vehicleModelo: s?.vehicleModelo || '',
        vehicleYear: s?.vehicleYear ? String(s?.vehicleYear) : '',
        vehiclePlacas: s?.vehiclePlacas || '',
        vin: s?.vin || '',
        observaciones: s?.description || '',
        urgency: s?.urgency || '',
        requestType: s?.requestType || '',
      });
      setShowDirectModal(true);
    }
  }, [location?.state?.fromSolicitud]);

  // Load inspection findings from DB when work order is selected
  const loadInspectionFindings = useCallback(async (workOrderId) => {
    if (!workOrderId) return;
    try {
      // JOIN vehicles and inspection_parts_required to get full data
      const { data } = await supabase
        ?.from('technical_inspections')
        ?.select(`
          id,
          category,
          findings,
          recommendations,
          status,
          horas_estimadas,
          refaccion,
          cantidad,
          requiere_mano_obra,
          vehicle:vehicles(id, vin, marca, modelo, year, motor, placas),
          parts:inspection_parts_required(id, part_description, quantity)
        `)
        ?.eq('work_order_id', workOrderId)
        ?.neq('status', 'no_aplica');

      if (data?.length > 0) {
        setInspectionFindings(data);

        // Extract vehicle info from first record that has it
        const vehicleData = data?.find(f => f?.vehicle?.vin || f?.vehicle?.marca)?.vehicle;
        if (vehicleData) setInspectionVehicle(vehicleData);

        // BAD statuses that require parts/labor
        const BAD = new Set(['malo', 'critico', 'requiere_atencion']);

        // Build quote items from inspection_parts_required rows (multi-row parts)
        const partItems = [];
        data
          ?.filter(f => BAD?.has(f?.status))
          ?.forEach(f => {
            // Add each part from inspection_parts_required
            if (f?.parts?.length > 0) {
              f?.parts?.forEach(p => {
                partItems?.push({
                  id: `part-${p?.id}`,
                  type: 'part',
                  description: p?.part_description,
                  quantity: p?.quantity || 1,
                  cost: 0,
                  price: 0,
                  margin: 0,
                  supplier: '',
                  notes: `[${f?.category}] ${f?.findings || ''}`,
                  addedAt: new Date()?.toISOString(),
                  fromInspection: true,
                  inspectionId: f?.id,
                  category: f?.category,
                });
              });
            } else if (f?.refaccion) {
              // Fallback: single refaccion field on technical_inspections
              partItems?.push({
                id: `insp-ref-${f?.id}`,
                type: 'part',
                description: f?.refaccion,
                quantity: f?.cantidad || 1,
                cost: 0,
                price: 0,
                margin: 0,
                supplier: '',
                notes: `[${f?.category}] ${f?.findings || ''}`,
                addedAt: new Date()?.toISOString(),
                fromInspection: true,
                inspectionId: f?.id,
                category: f?.category,
              });
            }

            // Add labor item if horas_estimadas > 0
            if ((f?.horas_estimadas > 0 || f?.requiere_mano_obra) && f?.category) {
              partItems?.push({
                id: `labor-${f?.id}`,
                type: 'labor',
                description: `Mano de obra — ${f?.category}`,
                quantity: f?.horas_estimadas || 1,
                cost: 0,
                price: 0,
                margin: 0,
                supplier: '',
                notes: f?.recommendations || f?.findings || '',
                addedAt: new Date()?.toISOString(),
                fromInspection: true,
                inspectionId: f?.id,
                category: f?.category,
                isLabor: true,
              });
            }
          });

        if (partItems?.length > 0) {
          setQuoteItems(prev => {
            const existingDescs = new Set(prev?.map(i => i?.description));
            const newItems = partItems?.filter(i => !existingDescs?.has(i?.description));
            return [...prev, ...newItems];
          });
        }
      }
    } catch (err) {
      console.warn('[QuotationManagement] loadInspectionFindings error:', err?.message);
    }
  }, []);

  // Load inspection findings by receptionId
  const loadInspectionFindingsByReception = useCallback(async (receptionId) => {
    if (!receptionId) return;
    try {
      const { data } = await supabase
        ?.from('technical_inspections')
        ?.select(`
          id,
          category,
          findings,
          recommendations,
          status,
          horas_estimadas,
          refaccion,
          cantidad,
          requiere_mano_obra,
          vehicle:vehicles(id, vin, marca, modelo, year, motor, placas),
          parts:inspection_parts_required(id, part_description, quantity)
        `)
        ?.eq('reception_id', receptionId)
        ?.neq('status', 'no_aplica');

      if (data?.length > 0) {
        setInspectionFindings(data);

        // Extract vehicle info from first record that has it
        const vehicleData = data?.find(f => f?.vehicle?.vin || f?.vehicle?.marca)?.vehicle;
        if (vehicleData) setInspectionVehicle(vehicleData);

        // BAD statuses that require parts/labor
        const BAD = new Set(['malo', 'critico', 'requiere_atencion']);

        // Build quote items from inspection_parts_required rows (multi-row parts)
        const partItems = [];
        data
          ?.filter(f => BAD?.has(f?.status))
          ?.forEach(f => {
            // Add each part from inspection_parts_required
            if (f?.parts?.length > 0) {
              f?.parts?.forEach(p => {
                partItems?.push({
                  id: `part-${p?.id}`,
                  type: 'part',
                  description: p?.part_description,
                  quantity: p?.quantity || 1,
                  cost: 0,
                  price: 0,
                  margin: 0,
                  supplier: '',
                  notes: `[${f?.category}] ${f?.findings || ''}`,
                  addedAt: new Date()?.toISOString(),
                  fromInspection: true,
                  inspectionId: f?.id,
                  category: f?.category,
                });
              });
            } else if (f?.refaccion) {
              // Fallback: single refaccion field on technical_inspections
              partItems?.push({
                id: `insp-ref-${f?.id}`,
                type: 'part',
                description: f?.refaccion,
                quantity: f?.cantidad || 1,
                cost: 0,
                price: 0,
                margin: 0,
                supplier: '',
                notes: `[${f?.category}] ${f?.findings || ''}`,
                addedAt: new Date()?.toISOString(),
                fromInspection: true,
                inspectionId: f?.id,
                category: f?.category,
              });
            }

            // Add labor item if horas_estimadas > 0
            if ((f?.horas_estimadas > 0 || f?.requiere_mano_obra) && f?.category) {
              partItems?.push({
                id: `labor-${f?.id}`,
                type: 'labor',
                description: `Mano de obra — ${f?.category}`,
                quantity: f?.horas_estimadas || 1,
                cost: 0,
                price: 0,
                margin: 0,
                supplier: '',
                notes: f?.recommendations || f?.findings || '',
                addedAt: new Date()?.toISOString(),
                fromInspection: true,
                inspectionId: f?.id,
                category: f?.category,
                isLabor: true,
              });
            }
          });

        if (partItems?.length > 0) {
          setQuoteItems(prev => {
            const existingDescs = new Set(prev?.map(i => i?.description));
            const newItems = partItems?.filter(i => !existingDescs?.has(i?.description));
            return [...prev, ...newItems];
          });
        }
      }
    } catch (err) {
      console.warn('[QuotationManagement] loadInspectionFindingsByReception error:', err?.message);
    }
  }, []);

  // Handle reception selection
  const handleSelectReception = useCallback((reception) => {
    setSelectedReceptionId(reception?.id);
    setInspectionFindings([]);
    setQuoteItems([]);
    setInspectionVehicle(null);
    setWorkOrderStatus(null);

    // Build a normalized selectedWorkOrder-like object for compatibility with existing UI
    const normalized = {
      id: reception?.id,
      receptionId: reception?.id,
      folio: `REC-${String(reception?.id)?.slice(-6)?.toUpperCase()}`,
      vehicle: reception?.vehicles
        ? `${reception?.vehicles?.marca} ${reception?.vehicles?.modelo} ${reception?.vehicles?.year}`
        : 'Vehículo',
      vin: reception?.vehicles?.vin || '',
      vehicleData: reception?.vehicles,
      client: reception?.clients?.nombre || 'Cliente',
      clientData: reception?.clients,
      status: reception?.status,
      companyId: reception?.company_id,
      inspectionDate: reception?.created_at
        ? new Date(reception?.created_at)?.toLocaleDateString('es-MX')
        : '-',
      isReceptionFlow: true,
    };
    setSelectedWorkOrder(normalized);
    setWorkOrderStatus('exists');
    loadInspectionFindingsByReception(reception?.id);
  }, [loadInspectionFindingsByReception]);

  // When a work order is selected, lazy-load or create sale_note + quotation
  useEffect(() => {
    if (!selectedWorkOrder?.id) {
      setSaleNote(null);
      setQuotation(null);
      setWorkOrderStatus(null);
      setInspectionFindings([]);
      setQuoteItems([]);
      setInspectionVehicle(null);
      return;
    }
    loadSaleNoteAndQuotation(selectedWorkOrder?.id, selectedWorkOrder?.companyId);
    checkInspectionExists(selectedWorkOrder?.id);
    loadInspectionFindings(selectedWorkOrder?.id);
  }, [selectedWorkOrder?.id, loadInspectionFindings]);

  // Validate that a finalized inspection exists before allowing quotation
  const checkInspectionExists = async (workOrderId) => {
    if (!workOrderId) return;
    setWorkOrderStatus('loading');
    try {
      const { data, error } = await supabase
        ?.from('technical_inspections')
        ?.select('id, status, created_at')
        ?.eq('work_order_id', workOrderId)
        ?.limit(1);

      if (error) {
        console.warn('[QuotationManagement] Error checking inspection:', error?.message);
        setWorkOrderStatus('missing');
        return;
      }
      setWorkOrderStatus(data?.length > 0 ? 'exists' : 'missing');
    } catch (err) {
      console.error('[QuotationManagement] checkInspectionExists error:', err);
      setWorkOrderStatus('missing');
    }
  };

  const loadSaleNoteAndQuotation = async (workOrderId, companyId) => {
    setLoadingSaleNote(true);
    try {
      // Try to fetch existing sale_note
      const existingSaleNote = await saleNoteService?.getByWorkOrderId(workOrderId);
      const existingQuotation = await quotationService?.getByWorkOrderId(workOrderId);

      setSaleNote(existingSaleNote);
      setQuotation(existingQuotation);
    } catch (err) {
      console.error('Error loading sale note/quotation:', err);
    } finally {
      setLoadingSaleNote(false);
    }
  };

  const handleCreateOrOpenSaleNote = async () => {
    if (!selectedWorkOrder?.id) {
      alert('Selecciona una Orden de Trabajo primero');
      return;
    }
    setCreatingSaleNote(true);
    try {
      console.log('[QuotationManagement] Opening/creating sale note for OT:', selectedWorkOrder?.id);
      const result = await saleNoteService?.ensureDraftForWorkOrder(
        selectedWorkOrder?.id,
        selectedWorkOrder?.companyId
      );
      if (result) {
        setSaleNote(result);
        const q = await quotationService?.getByWorkOrderId(selectedWorkOrder?.id);
        setQuotation(q);
        console.log('[QuotationManagement] Sale note ready, navigating to detail:', result?.id);
        navigate('/sale-note-detail', {
          state: {
            saleNote: result,
            saleNoteId: result?.id,
            workOrder: selectedWorkOrder,
            workOrderId: selectedWorkOrder?.id
          }
        });
      } else {
        console.error('[QuotationManagement] ensureDraftForWorkOrder returned null');
        alert('No se pudo crear la nota de venta. Verifica que la Orden de Trabajo existe y tiene company_id asignado.');
      }
    } catch (err) {
      console.error('[QuotationManagement] Error creating/opening sale note:', err);
      alert('Error al abrir la nota de venta: ' + (err?.message || 'Error desconocido'));
    } finally {
      setCreatingSaleNote(false);
    }
  };

  const handleGenerateQuotation = async () => {
    if (!selectedWorkOrder?.id) return;

    // Flow validation: block if no inspection
    if (workOrderStatus === 'missing') {
      alert('⚠️ No se puede generar cotización.\n\nEsta orden de trabajo no tiene una inspección finalizada.\n\nFlujo requerido: Ingreso → Inspección → Cotización');
      return;
    }

    setGeneratingQuotation(true);
    try {
      let currentSaleNote = saleNote;
      if (!currentSaleNote?.id) {
        currentSaleNote = await saleNoteService?.ensureDraftForWorkOrder(selectedWorkOrder?.id, selectedWorkOrder?.companyId);
        if (currentSaleNote) setSaleNote(currentSaleNote);
      }
      let currentQuotation = quotation;
      if (!currentQuotation?.id) {
        currentQuotation = await quotationService?.ensureDraftForWorkOrder(selectedWorkOrder?.id, currentSaleNote?.id, selectedWorkOrder?.companyId);
        if (currentQuotation) setQuotation(currentQuotation);
      }
      const { data: qrData } = await supabase
        ?.from('quote_requests')
        ?.select('*, items:quote_request_items(*)')
        ?.eq('work_order_id', selectedWorkOrder?.id)
        ?.maybeSingle();
      if (qrData?.items?.length > 0) {
        const prefilledItems = qrData?.items?.map(item => ({
          id: `qr-${item?.id}`,
          type: 'part',
          description: item?.item_name,
          quantity: item?.qty || 1,
          cost: 0,
          price: 0,
          margin: 0,
          supplier: item?.brand_preference || '',
          notes: item?.item_notes || '',
          addedAt: new Date()?.toISOString()
        }));
        setQuoteItems(prev => {
          const existingDescs = new Set(prev?.map(i => i?.description));
          const newItems = prefilledItems?.filter(i => !existingDescs?.has(i?.description));
          return [...prev, ...newItems];
        });
        console.log('[QuotationManagement] Pre-filled', prefilledItems?.length, 'items from quote_request');
      }
      setShowSuccessMessage(true);
      setTimeout(() => setShowSuccessMessage(false), 3000);
    } catch (err) {
      console.error('[QuotationManagement] Error generating quotation:', err);
      alert('Error al generar cotización: ' + (err?.message || 'Error desconocido'));
    } finally {
      setGeneratingQuotation(false);
    }
  };

  const fetchManagers = async () => {
    try {
      const { data, error } = await supabase
        ?.from('user_profiles')
        ?.select('id, full_name, email, role')
        ?.in('role', ['direccion', 'admin'])
        ?.order('full_name');

      if (error) {
        console.error('Error fetching managers:', error);
        return;
      }

      setManagers(data || []);
    } catch (err) {
      console.error('Failed to fetch managers:', err);
    }
  };

  const handleAddSuggestionToQuote = (suggestion) => {
    if (selectedSuggestions?.includes(suggestion?.id)) {
      setSelectedSuggestions(prev => prev?.filter(id => id !== suggestion?.id));
      setQuoteItems(prev => prev?.filter(item => item?.suggestionId !== suggestion?.id));
    } else {
      setSelectedSuggestions(prev => [...prev, suggestion?.id]);
      const newItem = {
        id: Date.now(),
        suggestionId: suggestion?.id,
        type: 'service',
        description: suggestion?.description,
        quantity: 1,
        cost: suggestion?.estimatedPrice * 0.65,
        price: suggestion?.estimatedPrice,
        margin: 53.85,
        supplier: suggestion?.supplier,
        addedAt: new Date()?.toISOString()
      };
      setQuoteItems(prev => [...prev, newItem]);
    }
  };

  const handleToggleSuggestion = (suggestion) => {
    handleAddSuggestionToQuote(suggestion);
  };

  const [editingItem, setEditingItem] = useState(null);

  const handleAddManualItem = (item) => {
    setQuoteItems(prev => [...prev, item]);
    setShowSuccessMessage(true);
    setTimeout(() => setShowSuccessMessage(false), 3000);
  };

  const handleSaveEditedItem = (updatedItem) => {
    setQuoteItems(prev => prev?.map(existing =>
      existing?.id === updatedItem?.id ? updatedItem : existing
    ));
    setShowSuccessMessage(true);
    setTimeout(() => setShowSuccessMessage(false), 3000);
  };

  const handleEditItem = (item) => {
    // kept for compatibility but inline editing is handled in QuoteItemsList
  };

  const handleRemoveItem = (itemId) => {
    setQuoteItems(prev => prev?.filter(item => item?.id !== itemId));
    const removedItem = quoteItems?.find(item => item?.id === itemId);
    if (removedItem?.suggestionId) {
      setSelectedSuggestions(prev => prev?.filter(id => id !== removedItem?.suggestionId));
    }
  };

  const handleRequestPriceChange = (item) => {
    setPriceChangeModal({ isOpen: true, item });
  };

  const handleViewSupplierQuotes = (item) => {
    setSelectedItemForQuotes(item);
  };

  const handleSelectSupplierQuote = (quote) => {
    if (!selectedItemForQuotes) return;
    
    setQuoteItems(prev => prev?.map(item => 
      item?.id === selectedItemForQuotes?.id 
        ? { 
            ...item, 
            price: quote?.quotedPrice,
            cost: quote?.quotedCost || item?.cost,
            margin: quote?.quotedCost 
              ? ((quote?.quotedPrice - quote?.quotedCost) / quote?.quotedCost * 100)
              : item?.margin,
            supplier: quote?.supplierName
          }
        : item
    ));
    
    setShowSuccessMessage(true);
    setTimeout(() => setShowSuccessMessage(false), 3000);
  };

  const handleConfirmPriceChange = (changeData) => {
    setQuoteItems(prev => prev?.map(item => 
      item?.id === changeData?.itemId 
        ? { 
            ...item, 
            price: changeData?.newPrice,
            margin: ((changeData?.newPrice - item?.cost) / item?.cost * 100),
            priceChangeReason: changeData?.reason,
            priceChangedAt: changeData?.timestamp
          }
        : item
    ));
    setPriceChangeModal({ isOpen: false, item: null });
    setShowSuccessMessage(true);
    setTimeout(() => setShowSuccessMessage(false), 3000);
  };

  const handleSendToSuppliers = async () => {
    if (!selectedWorkOrder) {
      alert('Seleccione una orden de trabajo primero');
      return;
    }

    if (quoteItems?.length === 0) {
      alert('Agregue al menos un item a la cotización');
      return;
    }

    // Filter only refacciones (exclude mano de obra / labor)
    const refacciones = quoteItems?.filter(item => {
      const tipo = (item?.type || item?.itemType || item?.category || '')?.toLowerCase();
      return tipo !== 'labor' && tipo !== 'mano_de_obra' && tipo !== 'mano de obra' && tipo !== 'labour';
    });

    if (refacciones?.length === 0) {
      alert('No hay refacciones en la cotización para enviar a proveedores. Los ítems de mano de obra no se envían.');
      return;
    }

    try {
      // Resolve actual work_order_id: in reception flow, selectedWorkOrder.id is a reception UUID
      let actualWorkOrderId = selectedWorkOrder?.id;
      if (selectedWorkOrder?.isReceptionFlow) {
        const { data: woData } = await supabase
          ?.from('work_orders')
          ?.select('id')
          ?.eq('reception_id', selectedWorkOrder?.id)
          ?.maybeSingle();
        actualWorkOrderId = woData?.id || null;
      }

      // Build vehicle info from vehicleData (reception flow) or inspectionVehicle (WO flow)
      const vd = selectedWorkOrder?.vehicleData || inspectionVehicle || {};
      const marca = vd?.marca || '';
      const modelo = vd?.modelo || '';
      const anio = vd?.year || vd?.año || '';
      const vin = vd?.vin || '';

      // Build formatted notes message
      const unitLines = [
        `Marca: ${marca || '-'}`,
        `Modelo: ${modelo || '-'}`,
        `Año: ${anio || '-'}`,
        `VIN: ${vin || '-'}`,
      ]?.join('\n');

      const partLines = refacciones
        ?.map((item, idx) => `${idx + 1}. ${item?.description || item?.name || 'Sin descripción'} — Cantidad: ${item?.quantity || 1}`)
        ?.join('\n');

      const notes = `DATOS DE LA UNIDAD:\n${unitLines}\n\nREFACCIONES A COTIZAR:\n${partLines}`;

      const supplierRequest = await supplierRequestService?.create(
        {
          workOrderId: actualWorkOrderId,
          notes
        },
        refacciones
      );

      console.log('Supplier request created:', supplierRequest);

      navigate('/supplier-coordination', {
        state: {
          workOrder: { ...selectedWorkOrder, vin: selectedWorkOrder?.vin || vin },
          quoteItems: refacciones,
          supplierRequest: supplierRequest
        }
      });
    } catch (error) {
      console.error('Error creating supplier request:', error);
      alert('Error al crear la solicitud de proveedores. Por favor intente nuevamente.');
    }
  };

  const handleSendToClient = () => {
    console.log('Sending to client:', quoteItems);
    alert('Cotización enviada al cliente por correo electrónico');
  };

  const handleMarkAsAuthorized = () => {
    console.log('Marking as authorized:', quoteItems);
    alert('Cotización marcada como autorizada. OT actualizada a estado "Aprobado"');
  };

  const handleSaveAsDraft = async () => {
    if (!quoteItems?.length) {
      alert('Agrega al menos un item a la cotización antes de guardar');
      return;
    }
    const now = new Date();
    const total = quoteItems?.reduce((sum, item) => sum + ((item?.price || 0) * (item?.quantity || 1)), 0);

    try {
      let savedId = null;
      // If there's an existing quotation in DB, update its status to 'guardada'
      if (quotationDB?.id) {
        const { error } = await supabase
          ?.from('quotations')
          ?.update({
            status: 'guardada',
            total,
            items_snapshot: quoteItems,
            updated_at: now?.toISOString(),
          })
          ?.eq('id', quotationDB?.id);

        if (error) {
          console.error('[handleSaveAsDraft] update error:', error?.message);
          alert('Error al guardar la cotización. Intente de nuevo.');
          return;
        }
        savedId = quotationDB?.id;
      } else {
        // Create a new quotation record with status 'guardada'
        const companyId = userProfile?.company_id || selectedWorkOrder?.companyId || null;
        const folioCot = selectedWorkOrder?.folio
          ? `COT-${selectedWorkOrder?.folio?.replace('OT-', '')}`
          : `COT-${Date.now()}`;

        const insertPayload = {
          status: 'guardada',
          total: quoteItems?.reduce((sum, item) => sum + ((item?.price || 0) * (item?.quantity || 1)), 0),
          items_snapshot: quoteItems,
          folio_cotizacion: folioCot,
          company_id: companyId,
          created_at: new Date()?.toISOString(),
          updated_at: new Date()?.toISOString(),
          origin: 'inspeccion',
          client_vehicle_snapshot: (() => {
            const vd = selectedWorkOrder?.vehicleData || inspectionVehicle || {};
            const cd = selectedWorkOrder?.clientData || {};
            return {
              clientNombre: cd?.nombre || selectedWorkOrder?.client || '',clientTelefono: cd?.telefono || '',vehicleMarca: vd?.marca || '',vehicleModelo: vd?.modelo || '',vehicleYear: vd?.year || vd?.año || '',vehiclePlacas: vd?.placas || '',vin: vd?.vin || '',
            };
          })(),
        };

        if (selectedWorkOrder?.id && !selectedWorkOrder?.isReceptionFlow && !selectedWorkOrder?.isDirectFlow) {
          insertPayload.work_order_id = selectedWorkOrder?.id;
        }
        if (selectedWorkOrder?.isReceptionFlow && selectedWorkOrder?.id) {
          insertPayload.reception_id = selectedWorkOrder?.id;
        }

        const { data: newQ, error } = await supabase?.from('quotations')?.insert(insertPayload)?.select()?.single();

        if (error) {
          console.error('[handleSaveAsDraft] insert error:', error?.message);
          alert('Error al guardar la cotización. Intente de nuevo.');
          return;
        }
        savedId = newQ?.id;
      }

      // Refresh saved quotations from DB
      await fetchSavedQuotations();
      // Refresh receptions so the saved one no longer appears in "Inspeccionadas"
      fetchReceptions()?.catch(() => {});
      setShowSuccessMessage(true);
      setTimeout(() => setShowSuccessMessage(false), 3000);

      // Build normalized quotation to open in SavedQuotationDetail
      const vd = selectedWorkOrder?.vehicleData || inspectionVehicle || {};
      const cd = selectedWorkOrder?.clientData || {};
      const vehicleStr = vd?.marca
        ? `${vd?.marca} ${vd?.modelo} ${vd?.year}`?.trim()
        : selectedWorkOrder?.vehicle || 'Vehículo';
      const savedAt = new Date()?.toISOString();
      const normalizedSaved = {
        id: savedId,
        folio: selectedWorkOrder?.folio
          ? `COT-${selectedWorkOrder?.folio?.replace('OT-', '')}`
          : `COT-${String(savedId)?.slice(0, 8)?.toUpperCase()}`,
        vehicle: vehicleStr,
        client: cd?.nombre || selectedWorkOrder?.client || 'Cliente',clientPhone: cd?.telefono || '',clientEmail: '',items: quoteItems,total,status: 'guardada',origin: 'inspeccion',work_order_id: selectedWorkOrder?.isReceptionFlow ? null : selectedWorkOrder?.id,savedAt,monthKey: '',monthLabel: '',
      };
      setMainTab('guardadas');
      setSelectedSavedQuotation(normalizedSaved);
    } catch (err) {
      console.error('[handleSaveAsDraft] failed:', err);
      alert('Error inesperado al guardar. Intente de nuevo.');
    }
  };

  const fetchSavedQuotations = useCallback(async () => {
    try {
      setLoadingSavedQuotations(true);
      const { data, error } = await supabase
        ?.from('quotations')?.select(`id,folio_cotizacion,status,total,created_at,items_snapshot,work_order_id,origin,work_order:work_orders!quotations_work_order_id_fkey(folio_ot,vehicle:vehicles(marca, modelo, year, placas),client:clients(nombre)),reception:receptions!quotations_reception_id_fkey(vehicles:vehicle_id(marca, modelo, year, placas),clients:client_id(nombre))`)?.in('status', ['guardada', 'aprobada'])
        ?.order('created_at', { ascending: false });

      if (error) {
        console.error('[fetchSavedQuotations] error:', error?.message);
        setSavedQuotations([]);
        return;
      }

      const normalized = (data || [])?.map(q => {
        const wo = q?.work_order;
        const rec = q?.reception;

        const vehicleObj = wo?.vehicle || rec?.vehicles;
        const clientObj = wo?.client || rec?.clients;

        const vehicleStr = vehicleObj
          ? `${vehicleObj?.marca || ''} ${vehicleObj?.modelo || ''} ${vehicleObj?.year || ''}`?.trim()
          : 'Vehículo';
        const clientStr = clientObj?.nombre || 'Cliente';

        const folio = q?.folio_cotizacion || q?.id?.slice(0, 8)?.toUpperCase();
        const savedAt = q?.created_at || new Date()?.toISOString();
        const dateObj = new Date(savedAt);
        const monthKey = `${dateObj?.getFullYear()}-${String(dateObj?.getMonth() + 1)?.padStart(2, '0')}`;
        const monthLabel = dateObj?.toLocaleString('es-MX', { month: 'long', year: 'numeric' });
        const items = Array.isArray(q?.items_snapshot) ? q?.items_snapshot : [];
        return {
          id: q?.id,
          folio,
          vehicle: vehicleStr,
          client: clientStr,
          items,
          total: Number(q?.total) || 0,
          status: q?.status,
          origin: q?.origin || 'inspeccion',
          work_order_id: q?.work_order_id || null,
          clientPhone: '',
          clientEmail: '',
          savedAt,
          monthKey,
          monthLabel,
        };
      });

      setSavedQuotations(normalized);
    } catch (err) {
      console.error('[fetchSavedQuotations] failed:', err);
      setSavedQuotations([]);
    } finally {
      setLoadingSavedQuotations(false);
    }
  }, []);

  // Fetch saved quotations on mount and when switching to guardadas tab
  useEffect(() => {
    fetchSavedQuotations();
  }, [fetchSavedQuotations]);

  const handleRequestApproval = () => {
    if (!selectedWorkOrder) {
      alert('Seleccione una orden de trabajo primero');
      return;
    }

    if (quoteItems?.length === 0) {
      alert('Agregue items a la cotización antes de solicitar aprobación');
      return;
    }

    setShowApprovalForm(true);
  };

  const handleSubmitApproval = async (approvalData) => {
    try {
      setSubmittingApproval(true);

      // Resolve actual work_order_id: in reception flow, selectedWorkOrder.id is a reception UUID
      let actualWorkOrderId = approvalData?.workOrderId;
      if (selectedWorkOrder?.isReceptionFlow) {
        const { data: woData } = await supabase
          ?.from('work_orders')
          ?.select('id')
          ?.eq('reception_id', selectedWorkOrder?.id)
          ?.maybeSingle();
        actualWorkOrderId = woData?.id || null;
        // No auto-create: OT must be created manually after authorization
      }

      await approvalService?.create({ ...approvalData, workOrderId: actualWorkOrderId });
      setShowApprovalForm(false);
      setShowSuccessMessage(true);
      setTimeout(() => setShowSuccessMessage(false), 5000);
    } catch (err) {
      console.error('Error submitting approval:', err);
      alert(err?.message || 'Error al enviar solicitud de aprobación');
    } finally {
      setSubmittingApproval(false);
    }
  };

  const calculateTotal = () => {
    return quoteItems?.reduce((sum, item) => sum + (item?.price * item?.quantity), 0);
  };

  const handleSendWhatsApp = async (phoneNumber) => {
    // ── 1. Validate phone BEFORE any async work ──────────────────────────────
    setWhatsAppError('');

    if (!phoneNumber || !phoneNumber?.trim()) {
      setWhatsAppError('El cliente no tiene número de WhatsApp registrado.');
      return;
    }

    // Normalize: remove spaces, dashes, parentheses, +, dots
    const cleanPhone = phoneNumber?.replace(/[\s\-().+]/g, '')?.replace(/[^0-9]/g, '');

    if (cleanPhone?.length < 7) {
      setWhatsAppError('Número de WhatsApp inválido. Revísalo en los datos del cliente.');
      return;
    }

    if (!selectedWorkOrder || quoteItems?.length === 0) {
      setWhatsAppError('Agregue partidas a la cotización antes de enviar.');
      return;
    }

    // ── 2. Build message immediately from state (no Supabase wait) ───────────
    const appUrl = window?.location?.origin;
    const quoteId = quotation?.id || '';
    const authUrl = quoteId ? `${appUrl}/authorize?quote_id=${quoteId}` : appUrl;

    const message = buildWhatsAppMessage({
      folioCotizacion: quotation?.folioCotizacion || quotation?.folio_cotizacion || '',
      folioRecepcion: selectedWorkOrder?.folio || '',
      clientName: selectedWorkOrder?.client || '',
      vehicle: selectedWorkOrder?.vehicleData || {},
      quoteItems,
      total: calculateTotal(),
      authUrl,
    });

    const waUrl = `https://wa.me/${cleanPhone}?text=${encodeURIComponent(message)}`;

    // ── 3. Open WhatsApp immediately ─────────────────────────────────────────
    window.open(waUrl, '_blank');

    setShowSuccessMessage(true);
    setTimeout(() => setShowSuccessMessage(false), 4000);

    // ── 4. Background: save snapshot + mark as sent (non-blocking) ───────────
    setSendingQuote(true);
    try {
      let currentQuotation = quotation;
      if (!currentQuotation?.id) {
        currentQuotation = await quotationService?.ensureDraftForWorkOrder(
          selectedWorkOrder?.id,
          saleNote?.id,
          selectedWorkOrder?.companyId
        );
        if (currentQuotation) setQuotation(currentQuotation);
      }

      if (currentQuotation?.id) {
        await supabase?.from('quotations')?.update({ items_snapshot: quoteItems })?.eq('id', currentQuotation?.id);
        const updatedQuote = await sendQuotation({
          quotationId: currentQuotation?.id,
          workOrderId: selectedWorkOrder?.id,
          via: 'whatsapp',
          sentTo: phoneNumber,
        });
        if (updatedQuote) setQuotation(updatedQuote);
      }
    } catch (err) {
      console.error('[QuotationManagement] handleSendWhatsApp background save error:', err);
    } finally {
      setSendingQuote(false);
      // Navigate to guardadas after sending
      await fetchSavedQuotations();
      setSelectedSavedQuotation(null);
      setMainTab('guardadas');
    }
  };

  const handleSendEmail = async (emailAddress) => {
    if (!selectedWorkOrder || quoteItems?.length === 0) {
      alert('Agregue partidas a la cotización antes de enviar');
      return;
    }
    setSendingQuote(true);
    try {
      // Ensure quotation exists
      let currentQuotation = quotation;
      if (!currentQuotation?.id) {
        currentQuotation = await quotationService?.ensureDraftForWorkOrder(
          selectedWorkOrder?.id,
          saleNote?.id,
          selectedWorkOrder?.companyId
        );
        if (currentQuotation) setQuotation(currentQuotation);
      }

      if (!currentQuotation?.id) {
        alert('No se pudo crear la cotización. Intente de nuevo.');
        return;
      }

      // Save items snapshot
      await supabase?.from('quotations')?.update({ items_snapshot: quoteItems })?.eq('id', currentQuotation?.id);

      // Mark as sent
      const updatedQuote = await sendQuotation({
        quotationId: currentQuotation?.id,
        workOrderId: selectedWorkOrder?.id,
        via: 'email',
        sentTo: emailAddress,
      });
      if (updatedQuote) setQuotation(updatedQuote);

      // Build auth URL
      const appUrl = window?.location?.origin;
      const authUrl = `${appUrl}/authorize?quote_id=${currentQuotation?.id}`;

      // Build email body
      const woDetails = await supabase
        ?.from('work_orders')
        ?.select('folio_ot, vehicle:vehicles(marca, modelo, year, vin, placas), client:clients(nombre)')
        ?.eq('id', selectedWorkOrder?.id)
        ?.maybeSingle();

      const emailBody = buildEmailBody({
        folioCotizacion: currentQuotation?.folioCotizacion || currentQuotation?.folio_cotizacion,
        folioRecepcion: woDetails?.data?.folio_ot || selectedWorkOrder?.folio,
        clientName: woDetails?.data?.client?.nombre || selectedWorkOrder?.client,
        vehicle: woDetails?.data?.vehicle || {},
        quoteItems,
        total: calculateTotal(),
        authUrl,
      });

      // Try to send via Resend edge function if available
      const supabaseUrl = import.meta.env?.VITE_SUPABASE_URL;
      const supabaseAnonKey = import.meta.env?.VITE_SUPABASE_ANON_KEY;
      if (supabaseUrl && supabaseAnonKey) {
        try {
          await fetch(`${supabaseUrl}/functions/v1/send-invoice-email`, {
            method: 'POST',
            headers: {
              'Content-Type': 'application/json',
              'Authorization': `Bearer ${supabaseAnonKey}`,
            },
            body: JSON.stringify({
              to: emailAddress,
              subject: `Cotización ${currentQuotation?.folioCotizacion || currentQuotation?.folio_cotizacion} - GearControl`,
              html: emailBody,
              workOrderId: selectedWorkOrder?.id,
            }),
          });
        } catch (emailErr) {
          console.warn('[QuotationManagement] Email send via edge function failed:', emailErr?.message);
        }
      }

      // Fallback: open mailto
      const subject = encodeURIComponent(`Cotización ${currentQuotation?.folioCotizacion || currentQuotation?.folio_cotizacion}`);
      const body = encodeURIComponent(`Estimado cliente,\n\nAdjunto encontrará su cotización.\n\nPara autorizar o rechazar visite:\n${authUrl}`);
      window?.open(`mailto:${emailAddress}?subject=${subject}&body=${body}`, '_blank');

      setShowSuccessMessage(true);
      setTimeout(() => setShowSuccessMessage(false), 4000);

      // Navigate to guardadas after sending email
      await fetchSavedQuotations();
      setSelectedSavedQuotation(null);
      setMainTab('guardadas');
    } catch (err) {
      console.error('[QuotationManagement] handleSendEmail error:', err);
      alert('Error al enviar por Email: ' + (err?.message || 'Error desconocido'));
    } finally {
      setSendingQuote(false);
    }
  };

  const handleApproveQuotation = async () => {
    if (!selectedWorkOrder || quoteItems?.length === 0) {
      alert('Debe seleccionar una orden de trabajo y agregar items a la cotización');
      return;
    }

    const confirmApproval = window.confirm(
      `¿Está seguro de aprobar esta cotización por $${calculateTotal()?.toLocaleString('es-MX', { minimumFractionDigits: 2 })}?\n\nEsto actualizará el estado de la orden a "Aprobado" y creará la Orden de Trabajo para Taller.`
    );

    if (!confirmApproval) return;

    try {
      setApprovingQuote(true);

      // Ensure quotation exists
      let currentQuotation = quotation;
      if (!currentQuotation?.id) {
        currentQuotation = await quotationService?.ensureDraftForWorkOrder(
          selectedWorkOrder?.id,
          saleNote?.id,
          selectedWorkOrder?.companyId
        );
        if (currentQuotation) setQuotation(currentQuotation);
      }

      if (currentQuotation?.id) {
        // Use the new flow service: approve quote + update work_order scope
        const result = await approveQuotationAndCreateWorkOrder({
          quotationId: currentQuotation?.id,
          workOrderId: selectedWorkOrder?.id,
          quoteItems,
          inspectionFindings,
          approvedBy: userProfile?.id,
        });
        if (result?.quotation) setQuotation(result?.quotation);
      } else {
        // Fallback: just update work order status
        await workOrderService?.updateStatus(selectedWorkOrder?.id, 'aprobado');
      }

      // Update sale_note status to aprobada if exists
      if (saleNote?.id) {
        await saleNoteService?.update(saleNote?.id, { status: 'aprobada' });
        setSaleNote(prev => prev ? { ...prev, status: 'aprobada' } : prev);
      }

      // Send approval notification email
      const supabaseUrl = import.meta.env?.VITE_SUPABASE_URL;
      const supabaseAnonKey = import.meta.env?.VITE_SUPABASE_ANON_KEY;
      if (supabaseUrl && supabaseAnonKey) {
        try {
          await fetch(`${supabaseUrl}/functions/v1/send-approval-notification`, {
            method: 'POST',
            headers: {
              'Content-Type': 'application/json',
              'Authorization': `Bearer ${supabaseAnonKey}`,
            },
            body: JSON.stringify({
              workOrderId: selectedWorkOrder?.id,
              quotationTotal: calculateTotal(),
              approvedBy: userProfile?.fullName || 'Equipo de Ventas',
              quoteItems: quoteItems?.map(item => ({
                description: item?.description,
                quantity: item?.quantity,
                price: item?.price,
                total: item?.price * item?.quantity,
              })),
            }),
          });
        } catch (emailError) {
          console.error('Error sending approval notification:', emailError);
        }
      }

      setShowSuccessMessage(true);
      setTimeout(() => setShowSuccessMessage(false), 5000);

      setQuoteItems([]);
      setSelectedSuggestions([]);
      setSelectedWorkOrder(null);
      setSaleNote(null);
      setQuotation(null);
    } catch (err) {
      console.error('Error approving quotation:', err);
      alert(err?.message || 'Error al aprobar la cotización');
    } finally {
      setApprovingQuote(false);
    }
  };

  const saleNoteStatusConfig = saleNote?.status
    ? (SALE_NOTE_STATUS_CONFIG?.[saleNote?.status] || SALE_NOTE_STATUS_CONFIG?.draft)
    : null;

  // When quoteItems change, initialize authorizedItemIds with all item ids (default all ON)
  useEffect(() => {
    if (quoteItems?.length > 0) {
      setAuthorizedItemIds(new Set(quoteItems?.map(i => i?.id)));
    }
  }, [quoteItems?.length]);

  const handleAuthorizationChange = (itemId, checked) => {
    setAuthorizedItemIds(prev => {
      const next = new Set(prev);
      if (checked) {
        next?.add(itemId);
      } else {
        next?.delete(itemId);
      }
      return next;
    });
  };

  const showAuthToast = (type, message) => {
    setAuthToast({ type, message });
    setTimeout(() => setAuthToast(null), 4000);
  };

  const handleAuthorizeQuotation = async () => {
    // Validate: at least 1 item authorized
    if (authorizedItemIds?.size === 0) {
      showAuthToast('error', 'Debe autorizar al menos un ítem de la cotización.');
      return;
    }
    // Validate: signature required
    if (!signatureDataUrl) {
      showAuthToast('error', 'La firma del cliente es obligatoria para autorizar.');
      return;
    }

    setAuthorizingQuote(true);
    try {
      // Ensure quotation exists — save directly without requiring work_order_id
      let currentQuotation = quotation;
      if (!currentQuotation?.id) {
        const companyId = userProfile?.company_id || selectedWorkOrder?.companyId || null;
        const folioCot = selectedWorkOrder?.folio
          ? `COT-${selectedWorkOrder?.folio?.replace('OT-', '')}`
          : `COT-${Date.now()}`;

        const insertPayload = {
          status: 'guardada',
          total: quoteItems?.reduce((sum, item) => sum + ((item?.price || 0) * (item?.quantity || 1)), 0),
          items_snapshot: quoteItems,
          folio_cotizacion: folioCot,
          company_id: companyId,
          created_at: new Date()?.toISOString(),
          updated_at: new Date()?.toISOString(),
          origin: 'inspeccion',
          client_vehicle_snapshot: (() => {
            const vd = selectedWorkOrder?.vehicleData || inspectionVehicle || {};
            const cd = selectedWorkOrder?.clientData || {};
            return {
              clientNombre: cd?.nombre || selectedWorkOrder?.client || '',
              clientTelefono: cd?.telefono || '',
              vehicleMarca: vd?.marca || '',
              vehicleModelo: vd?.modelo || '',
              vehicleYear: vd?.year || vd?.año || '',
              vehiclePlacas: vd?.placas || '',
              vin: vd?.vin || '',
            };
          })(),
        };

        if (selectedWorkOrder?.id && !selectedWorkOrder?.isReceptionFlow && !selectedWorkOrder?.isDirectFlow) {
          insertPayload.work_order_id = selectedWorkOrder?.id;
        }
        if (selectedWorkOrder?.isReceptionFlow && selectedWorkOrder?.id) {
          insertPayload.reception_id = selectedWorkOrder?.id;
        }

        const { data: newQ, error } = await supabase
          ?.from('quotations')
          ?.insert(insertPayload)
          ?.select()
          ?.single();

        if (error) {
          showAuthToast('error', 'No se pudo crear la cotización. Intente de nuevo.');
          return;
        }
        currentQuotation = newQ;
        setQuotation(newQ);
      }

      if (!currentQuotation?.id) {
        showAuthToast('error', 'No se pudo crear la cotización. Intente de nuevo.');
        return;
      }

      const LEGAL_NOTE = 'Declaro que AUTORIZO la realización de los trabajos seleccionados y la compra/instalación de las piezas descritas en esta cotización.';

      const authorizedSnapshot = quoteItems
        ?.filter(i => authorizedItemIds?.has(i?.id))
        ?.map(i => ({ ...i, authorized: true }));

      const { error } = await supabase
        ?.from('quotations')
        ?.update({
          status: 'aprobada',
          authorized_items_snapshot: authorizedSnapshot,
          signature_base64: signatureDataUrl,
          signed_at: new Date()?.toISOString(),
          authorized_note: LEGAL_NOTE,
          items_snapshot: quoteItems,
        })
        ?.eq('id', currentQuotation?.id);

      if (error) {
        console.error('[QuotationManagement] handleAuthorizeQuotation error:', error);
        showAuthToast('error', 'Error al guardar la autorización: ' + (error?.message || 'Error desconocido'));
        return;
      }

      setQuotation(prev => prev ? { ...prev, status: 'aprobada' } : prev);
      showAuthToast('success', 'Cotización autorizada correctamente');
      setShowAuthSection(false);
      setSignatureDataUrl(null);
      // Refresh saved quotations list
      await fetchSavedQuotations();
    } catch (err) {
      console.error('[QuotationManagement] handleAuthorizeQuotation catch:', err);
      showAuthToast('error', 'Error al autorizar: ' + (err?.message || 'Error desconocido'));
    } finally {
      setAuthorizingQuote(false);
    }
  };

  // ── PDF handlers ──
  const handlePreviewPdf = () => {
    if (!selectedWorkOrder || quoteItems?.length === 0) return;
    setPdfMode('preview');
  };

  const handleGeneratePdf = () => {
    if (!selectedWorkOrder || quoteItems?.length === 0) return;
    setPdfMode('generate');
  };

  const handlePrintPdf = () => {
    if (!selectedWorkOrder || quoteItems?.length === 0) return;
    setPdfMode('print');
  };

  // After PDF closes, if quotation was already saved, go to guardadas
  const handlePdfClose = async () => {
    setPdfMode(null);
    if (quotation?.status === 'guardada' || quotation?.status === 'aprobada') {
      await fetchSavedQuotations();
      setSelectedSavedQuotation(null);
      setMainTab('guardadas');
    }
  };

  // ── Direct quotation handler ──
  const handleCreateDirectQuotation = async ({ clientData, vehicleData, observaciones, items, solicitudId, clientId, vehicleId }) => {
    setCreatingDirectQuote(true);
    try {
      const { data: { user } } = await supabase?.auth?.getUser();
      const companyId = userProfile?.company_id || null;

      // Generate folio
      const folioCot = 'COT-DIR-' + Date.now()?.toString()?.slice(-6);

      // Compute total from items
      const total = items?.reduce((sum, item) => sum + ((item?.price || 0) * (item?.quantity || 1)), 0);

      // Store client + vehicle data as snapshot so it's retrievable in the list
      const clientVehicleSnapshot = {
        clientNombre: clientData?.nombre || '',
        clientTelefono: clientData?.telefono || '',
        vehicleMarca: vehicleData?.marca || '',
        vehicleModelo: vehicleData?.modelo || '',
        vehicleYear: vehicleData?.year || '',
        vehiclePlacas: vehicleData?.placas || '',
        vin: vehicleData?.vin || '',
      };

      // Insert quotation directly with status 'guardada' so it lands in Cotizaciones guardadas
      const { data: newQuotation, error: quotErr } = await supabase
        ?.from('quotations')
        ?.insert({
          company_id: companyId,
          folio_cotizacion: folioCot,
          status: 'guardada',
          origin: 'directa',
          notas: observaciones || null,
          items_snapshot: items,
          total,
          client_vehicle_snapshot: clientVehicleSnapshot,
          created_by: user?.id || null,
          ...(clientId ? { customer_id: clientId } : {}),
        })
        ?.select()
        ?.single();

      if (quotErr) {
        console.error('[DirectQuotation] Error inserting quotation:', quotErr);
        alert('Error al crear la cotización directa: ' + (quotErr?.message || 'Error desconocido'));
        return;
      }

      // Mark the service_request as 'cotizacion' so it no longer appears in Solicitudes directas
      if (solicitudId) {
        await supabase
          ?.from('service_requests')
          ?.update({ status: 'cotizacion' })
          ?.eq('id', solicitudId);
      }

      // Close modal immediately after successful save
      setShowDirectModal(false);
      setDirectModalInitialData(null);
      setShowSuccessMessage(true);
      setTimeout(() => setShowSuccessMessage(false), 4000);

      // Build normalized quotation object and open SavedQuotationDetail directly
      const vehicleStr = `${vehicleData?.marca || ''} ${vehicleData?.modelo || ''} ${vehicleData?.year || ''}`?.trim() || 'Vehículo';
      const savedAt = newQuotation?.created_at || new Date()?.toISOString();
      const normalizedNew = {
        id: newQuotation?.id,
        folio: newQuotation?.folio_cotizacion || folioCot,
        vehicle: vehicleStr,
        client: clientData?.nombre || 'Cliente',
        clientPhone: clientData?.telefono || '',
        clientEmail: '',
        items,
        total,
        status: newQuotation?.status || 'guardada',
        origin: 'directa',
        work_order_id: null,
        savedAt,
        monthKey: '',
        monthLabel: '',
      };

      // Navigate to SavedQuotationDetail immediately
      setMainTab('guardadas');
      setSelectedSavedQuotation(normalizedNew);

      // Refresh list and service requests in background (non-blocking)
      fetchSavedQuotations()?.catch(err => console.error('[DirectQuotation] fetchSavedQuotations error:', err));
      fetchServiceRequests()?.catch(err => console.error('[DirectQuotation] fetchServiceRequests error:', err));
    } catch (err) {
      console.error('[DirectQuotation] handleCreateDirectQuotation error:', err);
      alert('Error al crear cotización directa: ' + (err?.message || 'Error desconocido'));
    } finally {
      setCreatingDirectQuote(false);
    }
  };

  // Handle solicitud directa selection → open DirectQuotationModal pre-filled
  const handleSelectSolicitudDirecta = useCallback((solicitud) => {
    setDirectModalInitialData({
      solicitudId: solicitud?.id,
      clientId: solicitud?.client_id,
      vehicleId: solicitud?.vehicle_id,
      clientNombre: solicitud?.clients?.nombre || '',
      clientTelefono: solicitud?.clients?.telefono || '',
      vehicleMarca: solicitud?.vehicles?.marca || '',
      vehicleModelo: solicitud?.vehicles?.modelo || '',
      vehicleYear: solicitud?.vehicles?.year ? String(solicitud?.vehicles?.year) : '',
      vehiclePlacas: solicitud?.vehicles?.placas || '',
      vin: solicitud?.vehicles?.vin || '',
      observaciones: solicitud?.description || '',
      urgency: solicitud?.urgency || '',
      requestType: solicitud?.request_type || '',
    });
    setShowDirectModal(true);
  }, []);

  return (
    <>
      <Helmet>
<title>Cotización - Gearcontrol</title>
<meta name="description" content="Sistema de gestión de cotizaciones para taller automotriz con control de precios y márgenes" />
      </Helmet>
      <div className="min-h-screen bg-background">
        <MainSidebar isCollapsed={sidebarCollapsed} userRole="ventas" />

        <div className={`transition-smooth ${sidebarCollapsed ? 'lg:ml-20' : 'lg:ml-64'}`}>
          <header className="sticky top-0 z-40 bg-card border-b border-border shadow-elevation-1">
            <div className="flex items-center justify-between px-4 md:px-6 lg:px-8 py-4">
              <div className="flex items-center gap-4 min-w-0 flex-1">
                <button
                  onClick={() => setSidebarCollapsed(!sidebarCollapsed)}
                  className="hidden lg:flex p-2 rounded-lg hover:bg-muted transition-smooth press-effect focus-ring flex-shrink-0"
                  aria-label="Toggle sidebar"
                >
                  <Icon name={sidebarCollapsed ? 'ChevronRight' : 'ChevronLeft'} size={20} />
                </button>
                <div className="min-w-0 pl-10 lg:pl-0">
                  <h1 className="text-xl font-heading font-bold text-foreground leading-tight">
Cotización
                  </h1>
                  <p className="text-sm caption text-muted-foreground mt-1">
                    Creación y administración de presupuestos
                  </p>
                </div>
              </div>
              <div className="flex items-center gap-2 flex-shrink-0">
                <span className="hidden md:block text-sm caption text-muted-foreground">
                  {new Date()?.toLocaleDateString('es-MX', { 
                    weekday: 'long', 
                    year: 'numeric', 
                    month: 'long', 
                    day: 'numeric' 
                  })}
                </span>
                <button
                  onClick={() => setEvaModalOpen(true)}
                  className="flex items-center gap-2 px-3 py-2 rounded-lg bg-primary/10 text-primary border border-primary/20 hover:bg-primary/20 transition-colors text-sm font-medium"
                  title="Preguntar a EVA - Asistente IA"
                >
                  <Icon name="Bot" size={16} />
                  <span className="hidden sm:inline">Preguntar a EVA</span>
                </button>
                <button
                  onClick={() => setShowDirectModal(true)}
                  className="flex items-center gap-2 px-3 py-2 rounded-lg bg-accent/10 text-accent border border-accent/20 hover:bg-accent/20 transition-colors text-sm font-medium"
                  title="Crear cotización sin inspección previa"
                >
                  <Icon name="FilePlus" size={16} />
                  <span className="hidden sm:inline">Nueva cotización directa</span>
                </button>
              </div>
            </div>

            {/* Main tabs */}
            <div className="flex gap-1 px-4 md:px-6 lg:px-8 pb-0 border-t border-border">
              <button
                onClick={() => setMainTab('cotizar')}
                className={`flex items-center gap-2 px-4 py-3 text-sm font-medium border-b-2 transition-colors ${
                  mainTab === 'cotizar' ?'border-primary text-primary' :'border-transparent text-muted-foreground hover:text-foreground'
                }`}
              >
                <Icon name="FileText" size={16} />
                Cotizar
              </button>
            </div>
          </header>

          <main className="px-4 md:px-6 lg:px-8 py-6 md:py-8 space-y-6">
            <NavAcciones
              onRegresar={() => navigate(-1)}
              onSalir={async () => { await supabase?.auth?.signOut(); navigate('/signin'); }}
              label="Gestión de Cotizaciones"
            />
            {showSuccessMessage && (
              <div className="bg-success/10 border border-success/20 rounded-lg p-4 flex items-center gap-3">
                <Icon name="CheckCircle" size={24} className="text-success flex-shrink-0" />
                <p className="text-sm font-body text-success">
                  {mainTab === 'guardadas' ? 'Cotización guardada exitosamente' : 'Operación completada exitosamente'}
                </p>
              </div>
            )}

            {/* ── Cotizaciones Guardadas Tab ── */}
            {mainTab === 'guardadas' && selectedSavedQuotation && (
              <SavedQuotationDetail
                quotation={selectedSavedQuotation}
                onBack={() => setSelectedSavedQuotation(null)}
                onEdit={(q) => {
                  // Load the saved quotation into the cotizar tab for editing
                  setSelectedSavedQuotation(null);
                  setQuoteItems(Array.isArray(q?.items) ? q?.items : []);
                  setMainTab('cotizar');
                }}
                onRefresh={async () => {
                  await fetchSavedQuotations();
                  setSelectedSavedQuotation(null);
                }}
              />
            )}

            {/* ── Cotizaciones Guardadas Tab (list) ── */}
            {mainTab === 'guardadas' && !selectedSavedQuotation && (() => {
              // Compute unique months from saved quotations
              const monthsMap = {};
              savedQuotations?.forEach(q => {
                if (!monthsMap?.[q?.monthKey]) {
                  monthsMap[q?.monthKey] = q?.monthLabel;
                }
              });
              const months = Object.entries(monthsMap)?.sort((a, b) => b?.[0]?.localeCompare(a?.[0]));

              // Filter by search and month
              const filtered = savedQuotations?.filter(q => {
                const matchSearch = !savedSearch?.trim() ||
                  q?.folio?.toLowerCase()?.includes(savedSearch?.toLowerCase()) ||
                  q?.client?.toLowerCase()?.includes(savedSearch?.toLowerCase()) ||
                  q?.vehicle?.toLowerCase()?.includes(savedSearch?.toLowerCase());
                const matchMonth = !savedMonthFilter || q?.monthKey === savedMonthFilter;
                return matchSearch && matchMonth;
              });

              // Group by month
              const grouped = {};
              filtered?.forEach(q => {
                if (!grouped?.[q?.monthKey]) grouped[q?.monthKey] = { label: q?.monthLabel, items: [] };
                grouped?.[q?.monthKey]?.items?.push(q);
              });
              const groupedEntries = Object.entries(grouped)?.sort((a, b) => b?.[0]?.localeCompare(a?.[0]));

              return (
                <div className="space-y-6">
                  {/* Header */}
                  <div className="bg-card rounded-lg border border-border p-4 md:p-6">
                    <div className="flex items-center gap-2 mb-4">
                      <Icon name="FolderOpen" size={22} className="text-primary" />
                      <h2 className="text-xl font-heading font-bold text-foreground">Cotizaciones guardadas</h2>
                      <span className="ml-auto text-xs px-2 py-1 rounded-full bg-primary/10 text-primary font-semibold">
                        {savedQuotations?.length} total
                      </span>
                    </div>

                    {/* Search bar */}
                    <div className="relative mb-3">
                      <Icon name="Search" size={16} className="absolute left-3 top-1/2 -translate-y-1/2 text-muted-foreground" />
                      <input
                        type="text"
                        placeholder="Buscar por folio, cliente o vehículo..."
                        value={savedSearch}
                        onChange={e => setSavedSearch(e?.target?.value)}
                        className="w-full pl-9 pr-4 py-2 text-sm border border-border rounded-lg bg-background text-foreground placeholder:text-muted-foreground focus:outline-none focus:ring-2 focus:ring-primary"
                      />
                      {savedSearch && (
                        <button
                          onClick={() => setSavedSearch('')}
                          className="absolute right-3 top-1/2 -translate-y-1/2 text-muted-foreground hover:text-foreground"
                        >
                          <Icon name="X" size={14} />
                        </button>
                      )}
                    </div>

                    {/* Month filter */}
                    <div className="flex items-center gap-2">
                      <Icon name="CalendarDays" size={16} className="text-muted-foreground flex-shrink-0" />
                      <select
                        value={savedMonthFilter}
                        onChange={e => setSavedMonthFilter(e?.target?.value)}
                        className="flex-1 text-sm border border-border rounded-lg px-3 py-2 bg-background text-foreground focus:outline-none focus:ring-2 focus:ring-primary"
                      >
                        <option value="">Todos los meses</option>
                        {months?.map(([key, label]) => (
                          <option key={key} value={key} className="capitalize">{label}</option>
                        ))}
                      </select>
                      {savedMonthFilter && (
                        <button
                          onClick={() => setSavedMonthFilter('')}
                          className="text-xs text-muted-foreground hover:text-foreground px-2 py-1 rounded border border-border"
                        >
                          Limpiar
                        </button>
                      )}
                    </div>
                  </div>

                  {/* Loading state */}
                  {loadingSavedQuotations && (
                    <div className="flex items-center justify-center py-10 text-muted-foreground">
                      <Icon name="Loader2" size={20} className="animate-spin mr-2" />
                      <span className="text-sm">Cargando cotizaciones guardadas...</span>
                    </div>
                  )}

                  {/* Empty state */}
                  {!loadingSavedQuotations && savedQuotations?.length === 0 && (
                    <div className="bg-card rounded-lg border border-border p-10 text-center">
                      <Icon name="FolderOpen" size={40} className="text-muted-foreground mx-auto mb-3" />
                      <p className="text-sm font-medium text-foreground mb-1">No hay cotizaciones guardadas</p>
                      <p className="text-xs text-muted-foreground">Guarda una cotización desde el módulo de cotización para verla aquí.</p>
                    </div>
                  )}

                  {/* No results after filter */}
                  {!loadingSavedQuotations && savedQuotations?.length > 0 && filtered?.length === 0 && (
                    <div className="bg-card rounded-lg border border-border p-8 text-center">
                      <Icon name="SearchX" size={32} className="text-muted-foreground mx-auto mb-2" />
                      <p className="text-sm text-muted-foreground">No se encontraron cotizaciones con los filtros aplicados.</p>
                    </div>
                  )}

                  {/* Grouped list */}
                  {!loadingSavedQuotations && groupedEntries?.map(([monthKey, group]) => (
                    <div key={monthKey} className="bg-card rounded-lg border border-border overflow-hidden">
                      {/* Month header */}
                      <div className="flex items-center gap-2 px-4 py-3 bg-muted/50 border-b border-border">
                        <Icon name="CalendarDays" size={16} className="text-primary" />
                        <h3 className="text-sm font-heading font-semibold text-foreground capitalize">
                          {group?.label}
                        </h3>
                        <span className="ml-auto text-xs text-muted-foreground">
                          {group?.items?.length} cotización{group?.items?.length !== 1 ? 'es' : ''}
                        </span>
                      </div>
                      {/* Quotations list */}
                      <div className="divide-y divide-border">
                        {group?.items?.map(q => (
                          <button
                            key={q?.id}
                            onClick={() => {
                              setMainTab('guardadas');
                              setSelectedSavedQuotation(q);
                            }}
                            className="w-full text-left p-4 hover:bg-muted/30 transition-colors focus:outline-none focus:bg-muted/40"
                          >
                            <div className="flex items-start justify-between gap-3">
                              <div className="flex-1 min-w-0">
                                <div className="flex items-center gap-2 mb-1">
                                  <span className="text-sm font-heading font-bold text-primary">{q?.folio}</span>
                                  {q?.status === 'aprobada' ? (
                                    <span className="text-xs px-2 py-0.5 rounded-full bg-success/10 text-success font-medium">Autorizada</span>
                                  ) : (
                                    <span className="text-xs px-2 py-0.5 rounded-full bg-warning/10 text-warning font-medium">Pendiente</span>
                                  )}
                                  {q?.origin === 'directa' && (
                                    <span className="text-xs px-2 py-0.5 rounded-full bg-accent/10 text-accent font-medium flex items-center gap-1">
                                      <Icon name="FilePlus" size={10} />
                                      Directa
                                    </span>
                                  )}
                                </div>
                                <p className="text-sm font-body text-foreground truncate">{q?.vehicle}</p>
                                <p className="text-xs text-muted-foreground">{q?.client}</p>
                                <p className="text-xs text-muted-foreground mt-1">
                                  {new Date(q?.savedAt)?.toLocaleDateString('es-MX', { day: '2-digit', month: 'short', year: 'numeric', hour: '2-digit', minute: '2-digit' })}
                                </p>
                              </div>
                              <div className="text-right flex-shrink-0 flex flex-col items-end gap-2">
                                <p className="text-sm font-heading font-bold text-foreground">
                                  ${q?.total?.toLocaleString('es-MX', { minimumFractionDigits: 2 })}
                                </p>
                                <p className="text-xs text-muted-foreground">{q?.items?.length} item{q?.items?.length !== 1 ? 's' : ''}</p>
                                <span className="text-xs text-primary flex items-center gap-1 justify-end mt-1">
                                  <Icon name="ChevronRight" size={12} />
                                  Ver detalle
                                </span>
                              </div>
                            </div>
                            {/* Items summary */}
                            {q?.items?.length > 0 && (
                              <div className="mt-2 flex flex-wrap gap-1">
                                {q?.items?.slice(0, 3)?.map((item, idx) => (
                                  <span key={idx} className="text-xs px-2 py-0.5 rounded bg-muted text-muted-foreground truncate max-w-[160px]">
                                    {item?.description}
                                  </span>
                                ))}
                                {q?.items?.length > 3 && (
                                  <span className="text-xs px-2 py-0.5 rounded bg-muted text-muted-foreground">
                                    +{q?.items?.length - 3} más
                                  </span>
                                )}
                              </div>
                            )}
                          </button>
                        ))}
                      </div>
                    </div>
                  ))}
                </div>
              );
            })()}

            {/* ── Selector de unidad (solo en tab cotizar) ── */}
            {mainTab === 'cotizar' && (
              <div className="bg-card rounded-lg border border-border p-4 md:p-6">
                <div className="flex items-center justify-between mb-4">
                  <div className="flex items-center gap-2">
                    <Icon name="ClipboardCheck" size={24} className="text-primary" />
                    <h2 className="text-xl font-heading font-bold text-foreground uppercase tracking-wide">
                      {(selectedWorkOrder?.isReceptionFlow || selectedWorkOrder?.isDirectFlow) ? 'Unidad Seleccionada' : 'Seleccionar para Cotización'}
                    </h2>
                  </div>
                  {(selectedWorkOrder?.isReceptionFlow || selectedWorkOrder?.isDirectFlow) && (
                    <button
                      onClick={() => {
                        setSelectedWorkOrder(null);
                        setSelectedReceptionId(null);
                        setQuoteItems([]);
                        setSelectedSuggestions([]);
                        setSaleNote(null);
                        setQuotation(null);
                        setInspectionFindings([]);
                        setWorkOrderStatus(null);
                        setInspectionVehicle(null);
                      }}
                      className="flex items-center gap-2 px-3 py-2 rounded-lg border border-border hover:bg-muted transition-colors text-sm font-medium text-muted-foreground hover:text-foreground"
                    >
                      <Icon name="ArrowLeft" size={16} />
                      <span>Cambiar Unidad</span>
                    </button>
                  )}
                </div>

                {!selectedWorkOrder && (
                  <div className="flex gap-1 mb-5 p-1 bg-muted rounded-lg w-fit">
                    <button
                      onClick={() => setSelectionTab('inspeccionadas')}
                      className={`flex items-center gap-2 px-4 py-2 rounded-md text-sm font-medium transition-colors ${
                        selectionTab === 'inspeccionadas' ?'bg-card shadow-sm' :'text-muted-foreground hover:text-foreground'
                      }`}
                    >
                      <Icon name="ClipboardCheck" size={15} />
                      <span className="text-red-600 font-medium">Inspeccionadas</span>
                      {receptions?.length > 0 && (
                        <span className="ml-1 px-1.5 py-0.5 rounded-full bg-success/15 text-success text-xs font-semibold">
                          {receptions?.length}
                        </span>
                      )}
                    </button>
                    <button
                      onClick={() => setSelectionTab('solicitudes')}
                      className={`flex items-center gap-2 px-4 py-2 rounded-md text-sm font-medium transition-colors ${
                        selectionTab === 'solicitudes' ?'bg-card shadow-sm' :'text-muted-foreground hover:text-foreground'
                      }`}
                    >
                      <Icon name="MessageSquare" size={15} />
                      <span className="text-red-600 font-medium">Solicitudes directas</span>
                      {serviceRequests?.length > 0 && (
                        <span className="ml-1 px-1.5 py-0.5 rounded-full bg-blue-100 text-blue-700 text-xs font-semibold">
                          {serviceRequests?.length}
                        </span>
                      )}
                    </button>
                    <button
                      onClick={() => setSelectionTab('guardadas')}
                      className={`flex items-center gap-2 px-4 py-2 rounded-md text-sm font-medium transition-colors ${
                        selectionTab === 'guardadas' ?'bg-card shadow-sm' :'text-muted-foreground hover:text-foreground'
                      }`}
                    >
                      <Icon name="FolderOpen" size={15} />
                      <span className="text-red-600 font-medium">Cotizaciones guardadas</span>
                      {savedQuotations?.length > 0 && (
                        <span className="ml-1 px-1.5 py-0.5 rounded-full bg-primary/15 text-primary text-xs font-semibold">
                          {savedQuotations?.length}
                        </span>
                      )}
                    </button>
                  </div>
                )}

                {loadingReceptions || loadingServiceRequests ? (
                  <div className="flex items-center justify-center py-8">
                    <Icon name="Loader2" className="w-8 h-8 text-primary animate-spin mr-2" />
                  </div>
                ) : selectedWorkOrder?.isReceptionFlow ? (
                  <div className="p-4 rounded-lg border-2 border-primary bg-primary/5">
                    <div className="flex items-start justify-between mb-2">
                      <span className="text-sm font-mono font-bold text-primary">
                        REC-{String(selectedWorkOrder?.id)?.slice(-6)?.toUpperCase()}
                      </span>
                      <Icon name="CheckCircle" size={18} className="text-primary" />
                    </div>
                    <h3 className="text-base font-body font-semibold text-foreground mb-1">{selectedWorkOrder?.vehicle}</h3>
                    <p className="text-sm text-muted-foreground mb-1">{selectedWorkOrder?.client}</p>
                    <div className="flex items-center gap-2 text-xs text-muted-foreground">
                      <Icon name="Calendar" size={14} />
                      <span>Recepción: {selectedWorkOrder?.inspectionDate}</span>
                    </div>
                  </div>
                ) : selectedWorkOrder?.isDirectFlow ? (
                  <div className="p-4 rounded-lg border-2 border-accent bg-accent/5">
                    <div className="flex items-start justify-between mb-2">
                      <span className="text-sm font-mono font-bold text-accent">
                        SOL-{String(selectedWorkOrder?.id)?.slice(-6)?.toUpperCase()}
                      </span>
                      <span className="flex-shrink-0 text-[11px] px-2 py-0.5 rounded-full bg-accent/10 text-accent font-medium">
                        Solicitud directa
                      </span>
                    </div>
                    <h3 className="text-base font-body font-semibold text-foreground mb-1">{selectedWorkOrder?.vehicle}</h3>
                    <p className="text-sm text-muted-foreground mb-1">{selectedWorkOrder?.client}</p>
                    <div className="flex items-center gap-2 text-xs text-muted-foreground">
                      <Icon name="Calendar" size={14} />
                      <span>Cotización directa: {selectedWorkOrder?.inspectionDate}</span>
                    </div>
                  </div>
                ) : selectionTab === 'inspeccionadas' ? (
                  receptions?.length === 0 ? (
                    <div className="text-center py-8">
                      <Icon name="ClipboardX" className="w-12 h-12 text-muted-foreground mx-auto mb-3" />
                      <p className="text-muted-foreground">No hay unidades inspeccionadas disponibles</p>
                      <p className="text-sm text-muted-foreground mt-1">Completa una inspección para generar una cotización</p>
                    </div>
                  ) : (
                    <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-4">
                      {receptions?.map((rec) => (
                        <button
                          key={rec?.id}
                          onClick={() => handleSelectReception(rec)}
                          className="text-left p-4 rounded-lg border transition-smooth hover-lift press-effect focus-ring border-border hover:border-primary/50"
                        >
                          <div className="flex items-start justify-between mb-2 gap-2">
                            <span className="text-xs font-mono font-bold text-primary">
                              REC-{String(rec?.id)?.slice(-6)?.toUpperCase()}
                            </span>
                            <span className="text-xs px-2 py-0.5 rounded-full bg-success/10 text-success font-medium">Inspeccionado</span>
                          </div>
                          <h3 className="text-base font-body font-semibold text-foreground mb-1">
                            {rec?.vehicles
                              ? `${rec?.vehicles?.marca} ${rec?.vehicles?.modelo} ${rec?.vehicles?.year}`
                              : 'Vehículo'}
                          </h3>
                          {rec?.vehicles?.vin && <p className="text-xs font-mono text-foreground mb-1">{rec?.vehicles?.vin}</p>}
                          {rec?.vehicles?.placas && <p className="text-xs text-muted-foreground mb-1">Placas: {rec?.vehicles?.placas}</p>}
                          <p className="text-sm text-muted-foreground mb-1">{rec?.clients?.nombre || 'Cliente'}</p>
                          <div className="flex items-center gap-2 text-xs text-muted-foreground">
                            <Icon name="Calendar" size={14} />
                            <span>{rec?.created_at ? new Date(rec?.created_at)?.toLocaleDateString('es-MX') : '-'}</span>
                          </div>
                        </button>
                      ))}
                    </div>
                  )
                ) : selectionTab === 'solicitudes' ? (
                  serviceRequests?.length === 0 ? (
                    <div className="text-center py-8">
                      <Icon name="MessageSquareOff" className="w-12 h-12 text-muted-foreground mx-auto mb-3" />
                      <p className="text-muted-foreground">No hay solicitudes directas disponibles</p>
                    </div>
                  ) : (
                    <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-4">
                      {serviceRequests?.map((sol) => {
                        const urgColor = sol?.urgency === 'urgente' ?'bg-red-50 text-red-700 border-red-200' :'bg-gray-100 text-gray-600 border-gray-200';
                        return (
                          <button
                            key={sol?.id}
                            onClick={() => handleSelectSolicitudDirecta(sol)}
                            className="text-left p-4 rounded-lg border transition-smooth hover-lift press-effect focus-ring border-border hover:border-blue-400"
                          >
                            <div className="flex items-start justify-between mb-2 gap-2">
                              <span className="text-sm font-mono font-bold text-blue-700 truncate">
                                SOL-{String(sol?.id)?.slice(-6)?.toUpperCase()}
                              </span>
                              <span className="flex-shrink-0 text-[11px] px-2 py-0.5 rounded-full bg-blue-50 text-blue-700 border border-blue-200 font-semibold">
                                Solicitud directa
                              </span>
                            </div>
                            <p className="text-sm font-semibold text-foreground mb-1 truncate">{sol?.request_type || 'Sin tipo'}</p>
                            <div className="flex items-center gap-1 text-xs text-muted-foreground mb-1">
                              <Icon name="User" size={11} />
                              <span className="truncate">{sol?.clients?.nombre || '—'}</span>
                            </div>
                            {sol?.vehicles && (
                              <div className="flex items-center gap-1 text-xs text-muted-foreground mb-1">
                                <Icon name="Car" size={11} />
                                <span className="truncate">
                                  {sol?.vehicles?.marca} {sol?.vehicles?.modelo} {sol?.vehicles?.year}
                                  {sol?.vehicles?.placas ? ` · ${sol?.vehicles?.placas}` : ''}
                                </span>
                              </div>
                            )}
                            {sol?.description && (
                              <p className="text-xs text-foreground/70 line-clamp-2 bg-muted/40 rounded px-2 py-1 mb-2">{sol?.description}</p>
                            )}
                            <div className="flex items-center justify-between gap-2 mt-1">
                              <div className="flex items-center gap-1 text-xs text-muted-foreground">
                                <Icon name="Calendar" size={11} />
                                <span>{sol?.created_at ? new Date(sol?.created_at)?.toLocaleDateString('es-MX') : '—'}</span>
                              </div>
                              {sol?.urgency && (
                                <span className={`text-[11px] px-2 py-0.5 rounded-full border font-semibold ${urgColor}`}>
                                  {sol?.urgency === 'urgente' ? 'Urgente' : 'Normal'}
                                </span>
                              )}
                            </div>
                          </button>
                        );
                      })}
                    </div>
                  )
                ) : (
                  /* selectionTab === 'guardadas' — redirect to mainTab guardadas */
                  <div className="space-y-3">
                    {loadingSavedQuotations ? (
                      <div className="flex items-center justify-center py-8">
                        <Icon name="Loader2" className="w-6 h-6 text-primary animate-spin mr-2" />
                        <span className="text-sm text-muted-foreground">Cargando...</span>
                      </div>
                    ) : savedQuotations?.length === 0 ? (
                      <div className="text-center py-8">
                        <Icon name="FolderOpen" className="w-12 h-12 text-muted-foreground mx-auto mb-3" />
                        <p className="text-muted-foreground">No hay cotizaciones guardadas</p>
                      </div>
                    ) : (
                      savedQuotations?.slice(0, 10)?.map(q => (
                        <button
                          key={q?.id}
                          onClick={() => {
                            setMainTab('guardadas');
                            setSelectedSavedQuotation(q);
                          }}
                          className="w-full text-left p-4 rounded-lg border border-border hover:border-primary/50 transition-colors"
                        >
                          <div className="flex items-center justify-between gap-3">
                            <div className="flex-1 min-w-0">
                              <div className="flex items-center gap-2 mb-1">
                                <span className="text-sm font-heading font-bold text-primary">{q?.folio}</span>
                                {q?.status === 'aprobada' ? (
                                  <span className="text-xs px-2 py-0.5 rounded-full bg-success/10 text-success font-medium">Autorizada</span>
                                ) : (
                                  <span className="text-xs px-2 py-0.5 rounded-full bg-warning/10 text-warning font-medium">Pendiente</span>
                                )}
                                {q?.origin === 'directa' && (
                                  <span className="text-xs px-2 py-0.5 rounded-full bg-accent/10 text-accent font-medium">Directa</span>
                                )}
                              </div>
                              <p className="text-sm text-foreground truncate">{q?.vehicle}</p>
                              <p className="text-xs text-muted-foreground">{q?.client}</p>
                            </div>
                            <div className="text-right flex-shrink-0">
                              <p className="text-sm font-bold text-foreground">${q?.total?.toLocaleString('es-MX', { minimumFractionDigits: 2 })}</p>
                              <span className="text-xs text-primary flex items-center gap-1 justify-end mt-1">
                                <Icon name="ChevronRight" size={12} />
                                Ver detalle
                              </span>
                            </div>
                          </div>
                        </button>
                      ))
                    )}
                    {savedQuotations?.length > 10 && (
                      <button
                        onClick={() => setMainTab('guardadas')}
                        className="w-full text-center text-sm text-primary hover:underline py-2"
                      >
                        Ver todas ({savedQuotations?.length})
                      </button>
                    )}
                  </div>
                )}
              </div>
            )}

            {selectedWorkOrder && mainTab === 'cotizar' && (
              <>
                {/* ══════════════════════════════════════════════════════
                    BLOQUE RECIBE — datos de la unidad inspeccionada
                ══════════════════════════════════════════════════════ */}
                {/* Sale note status */}
                {saleNoteStatusConfig && (
                  <div className={`flex items-center gap-3 p-3 rounded-lg ${saleNoteStatusConfig?.bgColor}`}>
                    <Icon name={saleNoteStatusConfig?.icon} size={20} className={saleNoteStatusConfig?.color} />
                    <div>
                      <p className={`text-sm font-medium ${saleNoteStatusConfig?.color}`}>
                        Nota de Venta: {saleNoteStatusConfig?.label}
                      </p>
                      {saleNote?.folio_nota && (
                        <p className="text-xs text-muted-foreground">Folio: {saleNote?.folio_nota}</p>
                      )}
                    </div>
                  </div>
                )}

                {/* Inspection suggestions */}
                {inspectionFindings?.length > 0 && (
                  <InspectionSuggestions
                    findings={inspectionFindings}
                    onAddToQuote={handleAddSuggestionToQuote}
                    selectedSuggestions={selectedSuggestions}
                    onToggleSuggestion={handleToggleSuggestion}
                  />
                )}

                {/* Quote item form */}
                <QuoteItemForm
                  onAddItem={handleAddManualItem}
                  workOrderId={selectedWorkOrder?.id}
                  companyId={selectedWorkOrder?.companyId}
                  editingItem={editingItem}
                />

                {/* Quote items list */}
                <QuoteItemsList
                  items={quoteItems}
                  onEditItem={handleEditItem}
                  onRemoveItem={handleRemoveItem}
                  onRequestPriceChange={handleRequestPriceChange}
                  onViewSupplierQuotes={handleViewSupplierQuotes}
                  authorizedItemIds={showAuthSection ? authorizedItemIds : null}
                  onAuthorizationChange={showAuthSection ? handleAuthorizationChange : null}
                  onSaveEdit={handleSaveEditedItem}
                />

                {/* Authorization Section */}
                {showAuthSection && (
                  <div className="bg-card rounded-lg border-2 border-primary/30 p-4 md:p-6 space-y-4">
                    <div className="flex items-center gap-2 mb-2">
                      <Icon name="PenLine" size={24} className="text-primary" />
                      <h2 className="text-xl font-heading font-semibold text-foreground">
                        Autorización del Cliente
                      </h2>
                    </div>
                    <div className="bg-primary/5 border border-primary/20 rounded-lg p-4">
                      <p className="text-sm font-body text-foreground leading-relaxed">
                        <span className="font-semibold">Texto legal: </span>
                        Declaro que AUTORIZO la realización de los trabajos seleccionados y la compra/instalación de las piezas descritas en esta cotización.
                      </p>
                    </div>
                    <div>
                      <p className="text-sm font-medium text-foreground mb-2">Firma del cliente:</p>
                      <SignatureCanvas
                        onSave={(dataUrl) => setSignatureDataUrl(dataUrl)}
                        onClear={() => setSignatureDataUrl(null)}
                      />
                      {signatureDataUrl && (
                        <p className="text-xs text-success mt-1 flex items-center gap-1">
                          <Icon name="CheckCircle" size={12} />
                          Firma capturada
                        </p>
                      )}
                    </div>
                    <div className="flex gap-3">
                      <Button
                        variant="success"
                        iconName="CheckCircle"
                        iconPosition="left"
                        onClick={handleAuthorizeQuotation}
                        disabled={authorizingQuote || authorizedItemIds?.size === 0 || !signatureDataUrl}
                        loading={authorizingQuote}
                        fullWidth
                      >
                        Confirmar Autorización
                      </Button>
                      <Button
                        variant="outline"
                        onClick={() => {
                          setShowAuthSection(false);
                          setSignatureDataUrl(null);
                        }}
                        disabled={authorizingQuote}
                      >
                        Cancelar
                      </Button>
                    </div>
                  </div>
                )}

                <QuoteActions
                  hasItems={quoteItems?.length > 0}
                  onSendToSuppliers={handleSendToSuppliers}
                  onSendToClient={handleSendToClient}
                  onMarkAsAuthorized={handleMarkAsAuthorized}
                  onSaveAsDraft={handleSaveAsDraft}
                  onSendWhatsApp={handleSendWhatsApp}
                  onSendEmail={handleSendEmail}
                  onPreviewPdf={handlePreviewPdf}
                  onGeneratePdf={handleGeneratePdf}
                  onPrintPdf={handlePrintPdf}
                  isProcessing={sendingQuote}
                  quotationStatus={quotation?.status}
                  clientPhone={selectedWorkOrder?.clientData?.telefono || ''}
                  whatsAppError={whatsAppError}
                />

                {showApprovalForm && (
                  <ApprovalRequestForm
                    workOrderId={selectedWorkOrder?.id}
                    quotationTotal={calculateTotal()}
                    clientEmail={selectedWorkOrder?.client?.split(' ')?.[0]?.toLowerCase() + '@example.com'}
                    clientName={selectedWorkOrder?.client}
                    onSubmit={handleSubmitApproval}
                    onCancel={() => setShowApprovalForm(false)}
                    managers={managers}
                    isSubmitting={submittingApproval}
                  />
                )}

                {selectedWorkOrder && (
                  <ApprovalTracker workOrderId={selectedWorkOrder?.id} />
                )}
              </>
            )}

            {/* Auth toast */}
            {authToast && (
              <div className={`rounded-lg p-4 flex items-center gap-3 ${
                authToast?.type === 'success' ?'bg-success/10 border border-success/20' :'bg-destructive/10 border border-destructive/20'
              }`}>
                <Icon
                  name={authToast?.type === 'success' ? 'CheckCircle' : 'AlertCircle'}
                  size={24}
                  className={authToast?.type === 'success' ? 'text-success flex-shrink-0' : 'text-destructive flex-shrink-0'}
                />
                <p className={`text-sm font-body ${
                  authToast?.type === 'success' ? 'text-success' : 'text-destructive'
                }`}>
                  {authToast?.message}
                </p>
              </div>
            )}
          </main>
        </div>
      </div>
      <PriceChangeModal
        isOpen={priceChangeModal?.isOpen}
        onClose={() => setPriceChangeModal({ isOpen: false, item: null })}
        item={priceChangeModal?.item}
        onConfirm={handleConfirmPriceChange}
      />
      <EvaModal
        isOpen={evaModalOpen}
        onClose={() => setEvaModalOpen(false)}
        contexto="Cotización"
        datosIniciales={{
          hallazgos: quoteItems?.map(i => ({ descripcion: i?.description || i?.descripcion })),
        }}
      />
      {pdfMode && (
        <QuotationPdfTemplate
          selectedWorkOrder={selectedWorkOrder}
          quoteItems={quoteItems}
          quotation={quotation}
          signatureDataUrl={signatureDataUrl}
          observations={''}
          companyId={selectedWorkOrder?.companyId || userProfile?.company_id}
          mode={pdfMode}
          onClose={handlePdfClose}
        />
      )}
      {showDirectModal && (
        <DirectQuotationModal
          onClose={() => setShowDirectModal(false)}
          onConfirm={handleCreateDirectQuotation}
          isProcessing={creatingDirectQuote}
          initialData={directModalInitialData}
        />
      )}
    </>
  );
};

export default QuotationManagement;